import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider, useAuth } from './context/AuthContext';
import Sidebar from './components/Sidebar';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import WebhookDashboard from './pages/WebhookDashboard';
import WebhookForm from './pages/WebhookForm';
import FlightForm from './pages/FlightForm';
import TrackerDetails from './pages/TrackerDetails';
import UserDashboard from './pages/UserDashboard';
import UserForm from './pages/UserForm';
import BackButton from './components/BackButton';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <AppContent />
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
};

const AppContent = () => {
  const { user } = useAuth();
  const isAuthenticated = !!user;
  const isIuri = isAuthenticated && user.email === "iuribpmoro@gmail.com";

  return (
    <div style={{"margin-top":50}}>
      {isAuthenticated && <Sidebar />}
      {isAuthenticated && <BackButton />}
      <Routes>
        <Route path="/login" element={!isAuthenticated ? <Login /> : <Navigate to="/dashboard" />} />
        <Route path="/register" element={!isAuthenticated ? <Register /> : <Navigate to="/dashboard" />} />
        <Route path="/dashboard" element={isAuthenticated ? <Dashboard /> : <Navigate to="/login" />} />
        <Route path="/admin/users" element={isIuri ? <UserDashboard /> : <Navigate to="/login" />} />
        <Route path="/admin/users/add" element={isIuri ? <UserForm /> : <Navigate to="/login" />} />
        <Route path="/admin/users/edit/:id" element={isIuri ? <UserForm /> : <Navigate to="/login" />} />
        <Route path="/webhooks" element={isAuthenticated ? <WebhookDashboard /> : <Navigate to="/login" />} />
        <Route path="/webhooks/add" element={isAuthenticated ? <WebhookForm /> : <Navigate to="/login" />} />
        <Route path="/webhooks/edit/:id" element={isAuthenticated ? <WebhookForm /> : <Navigate to="/login" />} />
        <Route path="/flights/add" element={isAuthenticated ? <FlightForm /> : <Navigate to="/login" />} />
        <Route path="/flights/edit/:id" element={isAuthenticated ? <FlightForm /> : <Navigate to="/login" />} />
        <Route path="/flights/:id" element={isAuthenticated ? <TrackerDetails /> : <Navigate to="/login" />} />
        <Route path="/" element={<Navigate to={isAuthenticated ? "/dashboard" : "/login"} />} />
      </Routes>
    </div>
  );
};

export default App;
